module.exports = __webpack_public_path__ + "static/media/sprites.58d96202.png";